import { useTranslation } from 'react-i18next';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import LoadingButtonWrapper from '~/components/LoadingButtonWrapper';

type LaunchMigrationModalPropOptions = {
  open?: boolean;
  isPending?: boolean;
  handleContinue?: VoidFunction;
};

const LaunchMigrationModal = ({
  open = false,
  isPending = false,
  handleContinue = () => {},
}: LaunchMigrationModalPropOptions) => {
  const { t } = useTranslation('addSites', { keyPrefix: 'launchMigration' });
  return (
    <Dialog open={open}>
      <DialogTitle>{t('title')}</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <Divider />
          <Typography>{t('desc')}</Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <LoadingButtonWrapper loading={isPending} onClick={handleContinue}>
          {t('startTransfer')}
        </LoadingButtonWrapper>
      </DialogActions>
    </Dialog>
  );
};
export default LaunchMigrationModal;
